export default class UserModel {
  id!: number;

  nome!: string;
}
